/**
 * @generated SignedSource<<87b7b2c97bc09970b99a4c7c59af6de3>>
 * @relayHash ca96afdb191ace1658e7138e09f68d98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d57c5aa2501709c84ebb2ccbb5bf076d32ad8256d3bf18aa358f54a70584cfb8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d57c5aa2501709c84ebb2ccbb5bf076d32ad8256d3bf18aa358f54a70584cfb8",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
